module.exports = __webpack_public_path__ + "img/dashboardHero.e55302eb.jpg";